/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { StatusBarProps } from "./interfaces";
import { Steps } from "antd";
import { statusBarStyle } from "./styles";

export const StatusBar: React.FunctionComponent<StatusBarProps> = (props) => {
  const { Step } = Steps;
  const {
    changeDirection,
    currentState,
    showProgressDot,
    statusData,
    onClickChange,
  } = props;

  const onStatusBarChange = (current: number) => {
    onClickChange && onClickChange(current);
  };

  const mapData =
    statusData &&
    statusData.map((data, key) => {
      return (
        <Step
          title={data.title}
          description={data.description}
          key={key}
          icon={data.icon && <img src={data.icon} alt="" />}
        />
      );
    });
  return (
    <span css={statusBarStyle}>
      <Steps
        onChange={onStatusBarChange}
        progressDot={showProgressDot}
        current={currentState}
        direction={changeDirection}
      >
        {mapData}
      </Steps>
    </span>
  );
};
